import "./IconCustomerListGroup.scss";
import { ReactComponent as CustomerListGroupIcon } from "./svg/customerListGroup.svg";

interface Props {
  className?: string;
}

export const IconCustomerListGroup = ({ className = "" }: Props) => {
  return (
    <span className={`IconCustomerListGroup ${className}`}>
      <CustomerListGroupIcon />
    </span>
  );
};
